import { t } from "@bookingcom/lingojs-react";
import useRouteName from "hooks/useRouteName";
import { useSelector } from "react-redux";
import { getSearch } from "store/search/selectors";
import { getFlight } from "store/flightDetails/selectors";
import flights_apex_web_bf_baggage_per_person from "utils/experiments/apex/flights_apex_web_bf_baggage_per_person";

export const useGetFareFeaturesSubtitleCopy = () => {
  const routeName = useRouteName();
  const isCheckAndPay = routeName === "checkout-payment";

  const search = useSelector(getSearch);
  const flight = useSelector(getFlight);
  const totalTravellers = (search.adults || 0) + (search.children || []).length;

  const hasMultipleTravellers = totalTravellers > 1 || (flight?.travellers && flight?.travellers?.length > 1);

  const forAllTravellersVariant =
    hasMultipleTravellers && flights_apex_web_bf_baggage_per_person.trackWithDefaultStage() === 1;
  const forEachTravellerVariant =
    hasMultipleTravellers && flights_apex_web_bf_baggage_per_person.trackWithDefaultStage() === 2;

  const baseCopy = isCheckAndPay ? t("flights_pb_fare_subheader") : t("flight_fare_included");

  const headerCopy = forAllTravellersVariant
    ? t("flights_bf_included_total")
    : forEachTravellerVariant
    ? t("flights_bf_included_each")
    : baseCopy;

  return {
    headerCopy,
    forEachTravellerVariant
  };
};
